/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {
  CompetenceAndBehaviorIndicatorsIsUsedDto,
  CompetenceDto,
  CompetenceEducationDto,
  CompetenceTranslatedDto,
} from './models';
import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

/**
 * CompetenceApi - API class
 */
export class CompetenceApi extends LinqService {

  /**
   * Creates a new CompetenceApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: CompetenceDto, options?: QueryOptions) {
    // create query
    const url = `/Competence/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/Competence/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/Competence/GetAsync`;
    let query = this.createQuery<CompetenceDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/Competence/GetTranslatedAsync`;
    let query = this.createQuery<CompetenceTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param competenceAndBehaviorIndicatorsIsUsedDto 
   */
  isUsedBefore(competenceAndBehaviorIndicatorsIsUsedDto?: CompetenceAndBehaviorIndicatorsIsUsedDto, options?: QueryOptions) {
    // create query
    const url = `/Competence/IsUsedBefore`;
    let query = this.createQuery<boolean>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = competenceAndBehaviorIndicatorsIsUsedDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/Competence/List`;
    let query = this.createQuery<CompetenceDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/Competence/ListTranslated`;
    let query = this.createQuery<CompetenceTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: CompetenceDto, options?: QueryOptions) {
    // create query
    const url = `/Competence/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param competenceAndBehaviorIndicatorsIsUsedDto 
   */
  // goToEducation(competenceId?: string, options?: QueryOptions) {
  //   // create query
  //   const url = `/Competence/GoToEducation`;
  //   let query = this.createQuery<string>(url);

  //   // initialize options
  //   options = options || {};
  //   options.method = options.method || 'POST';
  //   options.params = options.params || [];
  //   options.headers = options.headers || {};

  //   // set body parameter
  //   options.data = competenceId;
  //   query = query.withOptions(options);

  //   return query.firstAsync();
  // }

  goToEducation(competenceId?: string, options?: QueryOptions) {
      // create query
      const url = `/Competence/GoToEducation`;
      let query = this.createQuery<CompetenceEducationDto>(url);
  
      // initialize options
      options = options || {};
      options.method = options.method || 'GET';
      options.params = options.params || [];
      options.headers = options.headers || {};
  
      // set query parameters
      options.params.push({ key: 'competenceId', value: competenceId && competenceId.toString() });
      // set query parameters
     // options.params.push({ key: 'pageNo', value: pageNo && pageNo.toString() });
      // set query parameters
      //options.params.push({ key: 'pageSize', value: pageSize && pageSize.toString() });
      query = query.withOptions(options);
  
      return query.firstAsync();
    }
}
